<template>
  <div>
    <div class="side">
      <div
        v-for="(item, index) in list"
        :key="item.name"
        :class="['side-item', { active: active === index + 1 }]"
        @click="goTo(item.name)"
      >
        <svg-icon class="svg" :icon-class="item.icon"></svg-icon>
        <div class="name">{{ item.name }}</div>
        <svg-icon class="arrow" icon-class="arrow-right"></svg-icon>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    active: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      list: [
        {
          name: "我的首页",
          icon: "icon-wdsy",
        },
        {
          name: "任务记录",
          icon: "icon-rwjl",
        },
        {
          name: "兑换历史",
          icon: "icon-dhls",
        },
        {
          name: "金币明细",
          icon: "icon-jbmx",
        },
        {
          name: "我的消息",
          icon: "icon-notice",
        },

        {
          name: "账户设置",
          icon: "icon-zhsz",
        },
        {
          name: "我的邀请",
          icon: "icon-wdyq",
        },
        {
          name: "我的信用值",
          icon: "icon-wdxyz",
        },
      ],
    };
  },
  methods: {
    goTo(data) {
      switch (data) {
        case "我的首页":
          this.$router.push("/module/home");
          break;
        case "任务记录":
          this.$router.push("/module/taskRecord");
          break;
        case "兑换历史":
          this.$router.push("/module/redemptionHistory");
          break;
        case "金币明细":
          this.$router.push("/module/goldHistory");
          break;
        case "账户设置":
          this.$router.push("/module/account");
          break;
        case "我的邀请":
          this.$router.push("/module/invite");
          break;
        case "我的信用值":
          this.$router.push("/module/creditValue");
          break;
        case "我的消息":
          this.$router.push("/module/notice");
          break;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.side {
  background-color: #fff;
  width: 180px;
  border-radius: 4px;
  padding: 8px;
  box-sizing: border-box;
  .side-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 42px;
    color: #474f66;
    cursor: pointer;
    margin-bottom: 6px;
    border-radius: 4px;
    .svg {
      width: 18px;
      height: 18px;
      margin-left: 12px;
      margin-right: 16px;
      flex-shrink: 0;
    }
    .name {
      font-size: 14px;
      width: 90px;
      flex-shrink: 0;
    }
    .arrow {
      margin-right: 12px;
      flex-shrink: 0;
      width: 14px;
      height: 14px;
    }
  }
  .side-item:hover {
    color: #8948ff;
    background-color: #f9f5ff;
  }
  .active {
    color: #8948ff;
    background-color: #f9f5ff;
  }
}
</style>
